import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
      event: "pageview",
      page: location.pathname + location.search,
    });
  }, [location]);
};

export default usePageTracking;
